module.exports = __webpack_public_path__ + "img/bg.4842e9d2.jpg";